export default function (ctx) {
  const loggedIn = ctx.app.$cookies.get('auth-token')
  ctx.store.commit('setLoggedIn', !!loggedIn)

  return true
}
